export const isEmpty = (val) => {
  if (val && parseInt(val) === 0) return false
  if (
    typeof val === 'undefined' ||
    val === 'null' ||
    val == null ||
    val === 'undefined' ||
    val === undefined ||
    val === ''
  ) {
    return true
  } else if (typeof val === 'object' && Object.keys(val).length === 0) {
    return true
  } else if (val instanceof Array && val.length === 0) {
    return true
  } else {
    return false
  }
}

const mixSpanMethod = {
  methods: {
    getColspan(column, conditions) {
      let rowList = this.tableColumn
      let len = rowList.length
      let arr = []
      for (var i = 0; i < len; i++) {
        let colspan = 1
        for (var j = i + 1; j < len; j++) {
          let bool = conditions.every((col) => {
            return (
              !isEmpty(rowList[i][col]) &&
              !isEmpty(rowList[j][col]) &&
              rowList[i][col] === rowList[j][col]
            )
          })
          if (
            bool &&
            !isEmpty(rowList[i][column]) &&
            !isEmpty(rowList[j][column]) &&
            rowList[i][column] === rowList[j][column]
          ) {
            colspan += 1
            arr[i] = colspan
            arr[j] = 0
            if (j === len - 1) i = j
          } else {
            colspan = 1
            if (!arr[i]) arr[i] = colspan
            i = j
            arr[j] = colspan
          }
        }
      }
      return arr
    },
    mergeCell({ row, column, rowIndex, columnIndex }) {
      if (!this.isViewPage) {
        return {
          rowspan: 1,
          colspan: 1
        }
      }

      let columnList = this.children.column.filter(item => !item.hide)
      let rowList = this.tableColumn
      let conditions = []

      if (rowList.length <= 1) {
        return {
          rowspan: 1,
          colspan: 1
        }
      } else {
        for (let i = 0, columnLen = columnList.length; i < columnLen; i++) {
          if (columnList[i].merge) {
            let arr = this.getColspan(columnList[i].prop, conditions)
            let index = this.column.index
              ? i + 1
              : i
            conditions.push(columnList[i].prop)
            if (columnIndex === index) {
              for (let j = 0, rowLen = rowList.length; j < rowLen; j++) {
                if (rowIndex === j) {
                  return {
                    rowspan: arr[j],
                    colspan: arr[j] > 0 ? 1 : 0
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

export default mixSpanMethod
